import { TODO, Timestamp } from '@b2c/types/index';
import angular from 'angular';
import { EventsDetailComboRequiredItemComponentModule } from '../components/detail-combo-required-item/detail-combo-required-item.component';
import { EventsDetailComboOptionalItemComponentModule } from '../components/detail-combo-optional-item/detail-combo-optional-item.component';
import { AnalyticsServiceModule } from '@b2c/common/services/analytics/analytics.service';
import { AuthServiceModule } from '@b2c/common/services/auth/auth.service';
import { ReviewsServiceModule } from '@b2c/common/services/reviews/reviews.service';
import { EventsServiceModule } from '@b2c/common/services/events/events.service';
import { ComboServiceModule } from '@b2c/common/services/combo/combo.service';
import { MembershipServiceModule } from '@b2c/common/services/membership/membership.service';
import { HelpersServiceModule } from '@b2c/common/services/helpers/helpers.service';
import { ThemesServiceModule } from '@b2c/common/services/themes/themes.service';

EventsDetailController.$inject = [
  '$scope',
  '$state',
  '$sce',
  '$filter',
  'AuthService',
  'EventTemplateData',
  'EventsService',
  'ComboTemplateData',
  'ComboService',
  'ReviewsService',
  'CalendarService',
  'HelpersService',
  'ThemesData',
  'ThemesService',
  'AnalyticsService',
  'MembershipService',
];

function EventsDetailController(
  $scope,
  $state,
  $sce,
  $filter,
  AuthService,
  EventTemplateData,
  EventsService,
  ComboTemplateData,
  ComboService,
  ReviewsService,
  CalendarService,
  HelpersService,
  ThemesData,
  ThemesService,
  AnalyticsService,
  MembershipService
) {
  $scope.eventsDetail = {
    model: {},
    vm: {
      entries: [],
    },
    date: false,
    isMobile: false,
    canUserReview: false,
    reviewFormShown: false,
    reviewComplete: false,
    hasMoreReviews: false,
    reviewToken: false,
    reviewPage: 1,
    reviewLimit: 5,
    tenantId: '',
    comboTemplateId: '',
    dateParam: '',
    safeDescription: '',
    changeDateLabel: 'Select a date',
    averageRating: 0,
    currentReview: {
      rating: 0,
      title: '',
      comment: '',
    },
    times: [],
    reviews: [],
    visitorHasReview: false,
    tenantAllowsRatings: true,
    visitorId: null,

    theme: ThemesService,

    init: function () {
      this.tenantId = $state.params.tenantId;
      this.comboTemplateId = $state.params.comboId;

      this.isMobile = window.CONFIG.mobile;

      if ($state.params.date) {
        this.date = $filter('date')($state.params.date, 'EEEE, MMMM d, yyyy');
        this.dateParam = '?date=' + CalendarService.toISO8601($state.params.date);
        this.changeDateLabel = 'Change Date';
      }

      AuthService.getCookie();

      this.visitorId = AuthService.cookie && AuthService.cookie.id;

      if (ThemesData.data && ThemesData.data.success) {
        this.success.initThemes(ThemesData);
      } else {
        this.error.initThemes(ThemesData);
      }

      if ($state.params.rev && AuthService.cookie) {
        this.reviewToken = $state.params.rev;
        this.canUserReview = true;
      }

      if (ComboTemplateData && ComboTemplateData.data.success) {
        this.success.initCombo(ComboTemplateData);
      } else {
        // Load template after cart so we can restore values
        if (EventTemplateData && EventTemplateData.data.success) {
          this.success.init(EventTemplateData);
        } else {
          this.error.init(EventTemplateData);
        }
        this.error.initCombo(ComboTemplateData);
      }

      $scope.$emit('App::UpdatePageTitle', {
        title: $scope.eventsDetail.model.name,
      });
    },

    hasReviews: function () {
      return this.reviews instanceof Array && this.reviews.length > 0;
    },

    getPrimaryImage: function (event) {
      var image;

      if (event) {
        image = EventsService.getPrimaryImage(event);
      } else {
        image = EventsService.getPrimaryImage(this.model);
      }

      return image;
    },

    getReviews: function (eventTemplateId) {
      ReviewsService.api.program
        .list({
          tenantId: this.tenantId,
          eventTemplateId: eventTemplateId,
          page: this.reviewPage,
          pageSize: this.reviewLimit,
        })
        .then(this.success.getReviews, this.error.getReviews);
    },

    createReview: function () {
      if (this.canUserReview && this.tenantAllowsRatings) {
        ReviewsService.api
          .create({
            tenantId: parseInt(this.tenantId, 10),
            eventTemplateId: this.model.id,
            visitorId: this.visitorId,
            reviewToken: this.reviewToken,
            rating: this.currentReview.rating,
            title: this.currentReview.title,
            comment: this.currentReview.comment,
          })
          .then(this.success.createReview, this.error.createReview);
      } else {
        //TODO: Need to implement
      }
    },

    updateReview: function (reviewId) {
      if (this.canUserReview && this.tenantAllowsRatings) {
        ReviewsService.api
          .update({
            id: this.currentReview.id,
            tenantId: parseInt(this.tenantId, 10),
            eventTemplateId: this.model.id,
            visitorId: this.visitorId,
            reviewToken: this.reviewToken,
            rating: this.currentReview.rating,
            title: this.currentReview.title,
            comment: this.currentReview.comment,
          })
          .then(this.success.updateReview, this.error.updateReview);
      } else {
        //TODO: Need to implement
      }
    },

    isEventType: function (type) {
      return this.model.eventType === type;
    },

    showReviewForm: function (review) {
      if (review) {
        this.currentReview = review;
      } else {
        this.resetCurrentReview();
      }
      this.reviewFormShown = true;
    },

    hideReviewForm: function () {
      this.reviewFormShown = false;
    },

    findReviewForVisitorById: function (id, list) {
      var result: { index: number; review: TODO; } | null = null;

      if (this.visitorId) {
        for (let i = 0, ii = list.length; i < ii; i++) {
          if (list[i].visitorId && list[i].visitorId === this.visitorId) {
            if (list[i].id && list[i].id === id) {
              result = {
                index: i,
                review: list[i],
              };
              break;
            }
          }
        }
      }

      return result;
    },

    findReviewForVisitor: function (list) {
      var result: { index: number; review: TODO; } | null = null;

      if (this.visitorId) {
        for (let i = 0, ii = list.length; i < ii; i++) {
          if (list[i].visitorId && list[i].visitorId === this.visitorId) {
            result = {
              index: i,
              review: list[i],
            };
            break;
          }
        }
      }

      return result;
    },

    toggleReviewForm: function () {
      this.reviewFormShown = !this.reviewFormShown;
    },

    reviewCancel: function () {
      this.hideReviewForm();
      this.resetCurrentReview();
    },

    reviewDone: function () {
      if (this.currentReview.id) {
        this.updateReview();
      } else {
        this.createReview();
      }
    },

    resetCurrentReview: function () {
      this.currentReview.title = '';
      this.currentReview.content = '';
    },

    order: function () {
      const nextPageUrlSegments: string[] = [];
      const nextPageQueryParams: {
        eventId: string;
        cart: boolean;
        date?: Timestamp;
      } = {
        eventId: this.model.id,
        cart: true,
      };

      AnalyticsService.event({
        name: 'Detail::Order',
        category: 'Events',
        label: this.model.id + ($state.params.date ? ' - ' + $state.params.date : ''),
      });

      if (this.date) {
        nextPageUrlSegments.push('/orders');
        nextPageUrlSegments.push(this.tenantId);
        nextPageUrlSegments.push('tickets');

        nextPageQueryParams.date = $state.params.date;
      } else {
        nextPageUrlSegments.push('/orders');
        nextPageUrlSegments.push(this.tenantId);
        nextPageUrlSegments.push('calendar');
      }

      var nextPageLink = HelpersService.makeUrl(nextPageUrlSegments, nextPageQueryParams);

      var url = '';

      if (
        this.model.hasOwnProperty('membership') &&
        this.model.membership.restrictions instanceof Array &&
        this.model.membership.restrictions.length > 0 &&
        !MembershipService.checkVerifiedMembership(this.tenantId)
      ) {
        var ref = nextPageLink;
        url = HelpersService.makeUrl(['/auth', this.tenantId, 'members'], { ref: ref });
      } else {
        url = nextPageLink;
      }

      HelpersService.setHref(url);
    },

    orderCombo: function () {
      var qs = '',
        url = '/orders/' + this.tenantId;

      if (ComboService.comboContainsType(this.model, 'any')) {
        // If there are choices involved we need to branch to a new view
        // Users will be allowed to choose which events they want to add to their combo
        url += '/combo?comboId=' + this.comboTemplateId;

        if (this.date) {
          url += '&date=' + $state.params.date;
        }

        HelpersService.setHref(url + '&cart' + HelpersService.appendDonationParams());
      } else {
        qs = '&eventIds=' + ComboService.getEventTemplateIds(this.model).join(',');
        // If it is simply a set combo we should follow the original flow
        if (this.date) {
          HelpersService.setHref(
            url +
              '/tickets?comboId=' +
              this.comboTemplateId +
              qs +
              '&date=' +
              encodeURIComponent($state.params.date) +
              '&cart' +
              HelpersService.appendDonationParams()
          );
        } else {
          HelpersService.setHref(
            url + '/calendar?comboId=' + this.comboTemplateId + qs + '&cart' + HelpersService.appendDonationParams()
          );
        }
      }

      AnalyticsService.event({
        name: 'Detail::OrderCombo',
        category: 'Events',
        label: this.comboTemplateId + ($state.params.date ? ' - ' + $state.params.date : ''),
      });
    },

    moreReviews: function () {
      this.reviewPage += 1;
      this.getReviews(this.model.id);
    },

    isMemberOnlyEvent: function () {
      var self = $scope.eventsDetail;

      return MembershipService.isMemberOnlyEvent(self.model);
    },

    getMemberOnlyCalloutMessage: function () {
      var self = $scope.eventsDetail;

      return MembershipService.getMemberOnlyCalloutMessage(self.model);
    },

    normalizePayload: function (payload) {
      var self = $scope.eventsDetail;
      var entries = payload.templates.entries.map(function (entry) {
        return self.normalizeEntries(entry);
      });

      return Object.assign({}, self.vm, { entries: entries });
    },

    normalizeEntries: function (entries) {
      var items = entries.summaries.map(function (entry) {
        var primaryImage = EventsService.getPrimaryImage(entry) || {};

        return {
          id: entry.id,
          name: entry.name,
          shortDescription: HelpersService.strip(entry.description, 300),
          primaryImage: {
            id: primaryImage.id,
            highRes: primaryImage.highRes,
            preview: primaryImage.preview,
            primary: primaryImage.primary,
            screen: primaryImage.screen,
            thumbnail: primaryImage.thumbnail,
            description: primaryImage.description,
          },
          images: entry.images || [],
        };
      });

      return {
        type: entries.type,
        quantity: entries.quantity,
        items: items,
      };
    },

    success: {
      init: function (response) {
        var self = $scope.eventsDetail;

        self.model = response.data.payload;
        self.model.eventType = 'event';
        self.safeDescription = $sce.trustAsHtml(self.model.description);
        //self.times = EventsService.getTimes(self.model.schedules, self.model.repeatCycle);
        if (self.model.stars > 0) {
          self.averageRating = self.model.stars / self.model.ratings;
        }

        if (self.tenantAllowsRatings) {
          self.getReviews(self.model.id);
        }
      },
      initCombo: function (response) {
        var i;
        var ii;
        var j;
        var jj;
        var entry;
        var self = $scope.eventsDetail;

        self.model = response.data.payload;
        self.model.eventType = 'combo';
        self.safeDescription = $sce.trustAsHtml(self.model.description);

        for (i = 0, ii = self.model.templates.entries.length; i < ii; i++) {
          entry = self.model.templates.entries[i];
          if (entry.template) {
            if (!entry.template.shortDescription) {
              entry.template.shortDescription = HelpersService.strip(entry.template.description, 300);
            }
          } else if (entry.summaries) {
            for (j = 0, jj = entry.summaries.length; j < jj; j++) {
              if (!entry.summaries[j].shortDescription) {
                entry.summaries[j].shortDescription = HelpersService.strip(entry.summaries[j].description, 300);
              }
            }
          }
        }

        self.shortDescription = self.model.shortDescription || HelpersService.strip(self.model.description, 300);

        self.vm = self.normalizePayload(response.data.payload);
      },

      getReviews: function (response) {
        var self = $scope.eventsDetail,
          index,
          spliceArgs,
          reviews = response.data.payload.reviews,
          summary = response.data.payload.summary,
          found;

        if (reviews instanceof Array && reviews.length > 0) {
          index = self.reviewPage * self.reviewLimit;
          spliceArgs = [index, 0].concat(reviews);
          Array.prototype.splice.apply(self.reviews, spliceArgs);
          found = self.findReviewForVisitor(response.data.payload.reviews || []);
          if (found && self.canUserReview) {
            self.visitorHasReview = true;
            found.review.visitorIsAuthor = true;
          }

          self.hasMoreReviews = true;
        }

        if (summary && summary.stars && summary.ratings) {
          self.averageRating = summary.stars / summary.ratings;
        }
      },
      createReview: function (response) {
        var json = $.parseJSON(response.data.payload);
        if (json) {
          $scope.eventsDetail.reviews.unshift(angular.extend(json, { visitorIsAuthor: true }));
        }
        $scope.eventsDetail.visitorHasReview = true;
        $scope.eventsDetail.reviewComplete = true;
        $scope.eventsDetail.hideReviewForm();
      },
      updateReview: function (response) {
        var reviewId = response.data.payload.id,
          self = $scope.eventsDetail,
          found = self.findReviewForVisitorById(reviewId, self.reviews || []);
        if (found) {
          self.reviews[found.index] = angular.extend(response.data.payload, { visitorIsAuthor: true });
        }
        self.reviewComplete = true;
        self.hideReviewForm();
      },
      initThemes: function (response) {
        var self = $scope.eventsDetail;
        self.tenantAllowsRatings = response.data.payload.company.reviews;
      },
    },

    error: {
      init: function (response) {},
      initCombo: function (response) {},
      getReviews: function (response) {},
      createReview: function (response) {
        //TODO: Need to implement
      },
      updateReview: function (response) {
        //TODO: Need to implement
      },
      initThemes: function (response) {},
    },
  };

  $scope.eventsDetail.init();
}

export const EventsDetailControllerModule = angular
  .module('acme.view.events.detail.controllers', [
    AuthServiceModule,
    EventsServiceModule,
    ComboServiceModule,
    HelpersServiceModule,
    ThemesServiceModule,
    ReviewsServiceModule,
    AnalyticsServiceModule,
    MembershipServiceModule,
    EventsDetailComboRequiredItemComponentModule,
    EventsDetailComboOptionalItemComponentModule,
  ])
  .controller('EventsDetailController', EventsDetailController).name;
